import React from 'react';
import PropTypes from 'prop-types';

const DashboardLibraryHeaderExport = ({
    isMobileMenuShown,
    cancelDashboardExportMode,
    numberOfDashboardsForExport,
    onExportDashboards
}) => {
    return (
        <>
            <div
                className={`glu-page__header ${
                    isMobileMenuShown
                    && 'glu-page__header--no-shadow'
                } glu-flex glu-flex-row glu-flex-grow glu-flex-align-center`}
            >
                <div className="glu-flex-grow">
                    <div className="glu-page__title">Check the box of each dashboard you want to export</div>
                </div>
                <div className="glu-flex-shrink">
                    <button
                        className="glu-btn glu-btn--secondary"
                        onClick={cancelDashboardExportMode}
                    >
                        Cancel
                    </button>
                </div>
                <div className="glu-flex-shrink">
                    <button
                        disabled={numberOfDashboardsForExport <= 0}
                        className="glu-btn glu-btn--primary"
                        onClick={onExportDashboards}
                    >
                        Export
                    </button>
                </div>
            </div>

        </>
    );
};

DashboardLibraryHeaderExport.propTypes = {
    isMobileMenuShown: PropTypes.bool.isRequired
};

export default DashboardLibraryHeaderExport;
